import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";

import { Stack } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import Slider from "react-slick";
import useResponsive from "src/hooks/useResponsive";

import Context from "../context";
import ConnectAccountPanel from "./ConnectAccountPanel/ConnectAccountPanel";
import EntitiesPanel from "./EntitiesPanel/EntitiesPanel";
import InfoPanelCard from "./InfoPanel/InfoPanelCard";
import ModeSwitch from "./ModeSwitch";

export default function DemoPanel() {
	const [isLoading, setIsLoading] = useState(false);
	const { values, state, actions } = useContext(Context);
	const isDownLg = useResponsive("down", "lg");

	const settings = {
		infinite: false,
		slidesToShow: 1,
		centerMode: true,
		speed: 200,
		variableWidth: true,
		initialSlide: 0,
		focusOnSelect: true
	};

	useEffect(() => {
		setIsLoading(true);
		setTimeout(() => setIsLoading(false), 200);
	}, [state.isMobile]);

	if (isLoading) {
		return (
			<Stack
				sx={{
					borderRadius: 2,
					flexGrow: 1,
					backgroundColor: values.pageBackgroundColor,
					margin: 5,
					justifyContent: "center"
				}}
			>
				{!isDownLg && <ModeSwitch />}
			</Stack>
		);
	}

	return (
		<Stack
			sx={{
				borderRadius: 2,
				flexGrow: 1,
				backgroundColor: values.pageBackgroundColor,
				margin: 5,
				justifyContent: "center"
			}}
		>
			<Slider {...settings} beforeChange={(_current, next) => actions.onChangeSlide(next)}>
				<InfoPanelCard sx={{ marginRight: 3 }} isSelected={state.slideSelected === 0} />
				<EntitiesPanel isSelected={state.slideSelected === 1} />
				<ConnectAccountPanel sx={{ marginLeft: 3 }} isSelected={state.slideSelected === 2} />
			</Slider>
			{!isDownLg && <ModeSwitch />}
		</Stack>
	);
}
